"use client";
import { SelectedLanguage, SelectedLanguageMaxAge } from "../../../../constants/cookies.js";
import { useEffect } from "react";
import { useCookie } from "../../../../hooks/useCookie/index.js";
const getDomainByUrl = (url) => {
  const hostname = url.hostname.split(".");
  const len = hostname.length;
  if (len < 2) {
    return hostname[0];
  }
  return ["", hostname[len - 2], hostname[len - 1]].join(".");
};
function SynchronizeLanguage() {
  const [langCookie, updateLangCookie] = useCookie(SelectedLanguage);
  useEffect(() => {
    const url = new URL(window.location.href);
    const { searchParams } = url;
    if (!searchParams.has("langId")) {
      return;
    }
    const langId = searchParams.get("langId");
    if (langId === langCookie) {
      return;
    }
    updateLangCookie(langId, {
      domain: getDomainByUrl(url),
      maxAge: SelectedLanguageMaxAge
    });
  }, []);
  return null;
}
export {
  SynchronizeLanguage
};
